import { gql } from '@apollo/client';
import gqlClient from '../../../../../utils/apolloClient';

const updateSectionMutation = gql`
  mutation ($pk_columns: area_sections_pk_columns_input!, $set: area_sections_set_input!) {
    update_area_sections_by_pk(pk_columns: $pk_columns, _set: $set) {
      id
    }
  }
`;

export const updateSection = async (variables: object) => {
  return await gqlClient.mutate<{
    update_area_sections_by_pk: {
      id: string,
    }
  }>({ mutation: updateSectionMutation!, variables });
}
